export default "__VITE_ASSET__B3$8wCKn__"